//
export default [
    {
        name: 'name',
        type: 'text-field',
        props: {
            label: 'Nombre',
        },
    },
]
